module.exports = __webpack_public_path__ + "img/img (44).176822e7.png";